import React, { Component} from 'react';
import { getSingleMedicalRecord, deleteMedicalImage } from '../../services'
import EnhancedMedicalRecord from './EnhancedMedicalRecord';
import { medicalSubDocument, medicalDocument } from '../configData';
import Loader from '../../Loader'

class EditMedicalRecord extends Component {
  state = {
    loading: true,
    medicalRecord: '',
    recordId: ''
  }

  async componentDidMount() {
    const recordId = this.props.match.params.id;
    let data = {
      recordId
    }

    const response = await getSingleMedicalRecord(data);
    
    let files = response.data.record.document.files.map((file, index) => {
      return  {fileId: file._id, filename: file.filename, uploaded: true }
    });

    this.setState(prevState => ({
      loading: false,
      recordId: recordId,
      medicalRecord: response.data.record,
      files: files
    }))
  }

  deleteImage = async (imageId) => {
    
    let data = {
      recordId: this.state.recordId,
      imageId
    }
    
    const response = await deleteMedicalImage({data});
    
    this.setState(prevState => ({
      files: prevState.files.filter((file) => file.fileId !== imageId)
    })) 
  }

  render() {

    if(this.state.loading == true) {
      return (
        <Loader />
      )
    }

    const { medicalRecord, recordId, files } = this.state
    console.log(medicalRecord)
    return (
      <EnhancedMedicalRecord
        medicalId={recordId} 
        hospital={medicalRecord.hospitalName}
        phone={medicalRecord.phone}
        gyno={medicalRecord.doctorName}
        documentType={medicalDocument[medicalRecord.document.documentType]}
        appointment={new Date(medicalRecord.document.appointment)}
        subDocumentType={medicalSubDocument[medicalRecord.subDocumentType]}
        title={medicalRecord.document.title}
        description={medicalRecord.document.description}
        files={files}
        formType="edit"
        deleteImage={this.deleteImage}
      />
    )
  }
}

export default EditMedicalRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/GeneralMedicalRecord/EditMedicalRecord.js